import { css as baseCss } from "styled-components";

// FIXME: Either add this to app/src/webapp/styled-components.tsx,
// or breat app/src/webapp/styled-components.tsx into its own package.
export const disabledProps = baseCss`
opacity: 0.4;
pointer-events: none;
`;
